module.exports = __webpack_public_path__ + "product-ranking.svg?0f9d7da527a4703390a4b3b36db34543";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-ranking.svg
// module id = 313
// module chunks = 2